import { IMPORT_SURVEY, RESET } from "../types";

export default function(state = [], action) {
  switch (action.type) {
    case IMPORT_SURVEY:
      return action.survey.blocks;

    case RESET:
      return [];

    default:
      return state;
  }
}
